// ContactModal.js — Formulaire de contact + signalement de fiche

import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

export function ContactModal({ onClose, reportEvent = null }) {
  const isReport = !!reportEvent;

  const [form, setForm] = useState({
    name:    '',
    email:   '',
    subject: isReport ? `Signalement : ${reportEvent.title}` : '',
    message: isReport
      ? `Bonjour,\n\nJe souhaite signaler un problème avec la fiche "${reportEvent.title}" (${reportEvent.year > 0 ? reportEvent.year : Math.abs(reportEvent.year) + ' av. J.-C.'}).\n\nProblème constaté :\n`
      : '',
    type:    isReport ? 'report' : 'contact',
  });

  const [sending, setSending] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.email || !form.message) {
      setError('Email et message sont obligatoires.');
      return;
    }
    setSending(true);
    setError('');

    try {
      // Stocke dans Supabase table "contacts"
      const { error: dbErr } = await supabase.from('contacts').insert({
        name:       form.name    || 'Anonyme',
        email:      form.email,
        subject:    form.subject || (isReport ? 'Signalement fiche' : 'Contact'),
        message:    form.message,
        type:       form.type,
        event_id:   reportEvent?.id   || null,
        event_title:reportEvent?.title || null,
        created_at: new Date().toISOString(),
      });

      if (dbErr) throw dbErr;
      setSent(true);
    } catch (e) {
      setError('Erreur lors de l\'envoi. Réessayez ou écrivez directement à charl.delattre@gmail.com');
    }
    setSending(false);
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box contact-modal">

        {/* Header */}
        <div className="modal-header">
          <div className="modal-title-block">
            <span style={{ fontSize: 20 }}>{isReport ? '🚩' : '✉️'}</span>
            <h2 className="modal-title">
              {isReport ? 'Signaler une fiche' : 'Nous contacter'}
            </h2>
          </div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        {sent ? (
          <div className="contact-success">
            <span style={{ fontSize: 48 }}>✅</span>
            <h3>Message envoyé !</h3>
            <p>Merci pour votre {isReport ? 'signalement' : 'message'}. Nous vous répondrons à <strong>{form.email}</strong> dans les plus brefs délais.</p>
            <button className="submit-btn" onClick={onClose}>Fermer</button>
          </div>
        ) : (
          <div className="contact-form">

            {isReport && (
              <div className="contact-report-banner">
                <span>🚩</span>
                <div>
                  <strong>Fiche signalée :</strong> {reportEvent.title}
                  <p>Décrivez le problème dans le message ci-dessous.</p>
                </div>
              </div>
            )}

            {!isReport && (
              <div className="contact-types">
                {[
                  { id: 'contact',     label: '💬 Question générale' },
                  { id: 'suggestion',  label: '💡 Suggestion' },
                  { id: 'bug',         label: '🐛 Bug / Problème' },
                  { id: 'partnership', label: '🤝 Partenariat' },
                ].map(t => (
                  <button key={t.id}
                    className={`contact-type-btn ${form.type === t.id ? 'active' : ''}`}
                    onClick={() => set('type', t.id)}>
                    {t.label}
                  </button>
                ))}
              </div>
            )}

            <div className="contact-row">
              <div className="contact-field">
                <label>Nom (optionnel)</label>
                <input
                  type="text"
                  placeholder="Votre nom"
                  value={form.name}
                  onChange={e => set('name', e.target.value)}
                />
              </div>
              <div className="contact-field">
                <label>Email *</label>
                <input
                  type="email"
                  placeholder="votre@email.com"
                  value={form.email}
                  onChange={e => set('email', e.target.value)}
                />
              </div>
            </div>

            {!isReport && (
              <div className="contact-field">
                <label>Sujet</label>
                <input
                  type="text"
                  placeholder="Sujet de votre message"
                  value={form.subject}
                  onChange={e => set('subject', e.target.value)}
                />
              </div>
            )}

            <div className="contact-field">
              <label>Message *</label>
              <textarea
                placeholder={isReport
                  ? "Décrivez le problème : information incorrecte, image inappropriée, lien cassé..."
                  : "Votre message..."}
                value={form.message}
                onChange={e => set('message', e.target.value)}
                rows={6}
              />
            </div>

            {error && <p className="contact-error">{error}</p>}

            <div className="contact-footer">
              <span className="contact-mailto">
                Ou directement :
                <a href="mailto:charl.delattre@gmail.com">charl.delattre@gmail.com</a>
              </span>
              <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={sending}
              >
                {sending ? '⏳ Envoi…' : isReport ? '🚩 Envoyer le signalement' : '✉️ Envoyer'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
